import * as React from "react";
import { Card, Stack } from "@mui/material";
import { SimpleBreadcrumbs } from "../../components/navigation/simpleBreadcrumbs";
import StandardLayout from "../../layouts/standard";
import FastAccess from "./homeDetails/fastAccess";
import Information from "./homeDetails/information";
import SystemAlert from "./systemAlert";
import HomeTitleBar from "./homeDetails/homeTitleBar";
import HomeRecentActivity from "./homeDetails/recentActivity";
import { UserClaimsService } from "../../services/currentUserService/currentUserService";

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
    const breadcrumbs = <SimpleBreadcrumbs></SimpleBreadcrumbs>;
    const claimService = new UserClaimsService();
    const showRecentActivity = claimService.IsUserCclAdminOrSuperAdmin();

    return (
        <StandardLayout breadcrumbs={breadcrumbs}>
            <Card sx={{ height: "100%", width: "100%", padding: 2 }}>
                <Stack direction={"column"} spacing={1}>
                    <HomeTitleBar />
                    <SystemAlert tag="SystemAlert" title="General System Alert" />
                    <FastAccess />
                    <Information />
                    {showRecentActivity && <HomeRecentActivity />}
                </Stack>
            </Card>
        </StandardLayout>
    );
};

export default Home;
